import { HOUR_IN_MILLISECONDS } from 'config';
import {
  ProjectDto,
  useProjectQuery
} from 'providers/api';
import { UseQueryResult } from 'react-query';
import { PourPresetGroupsPageParams } from './constants';

export type PourPresetGroupsQueries = [
  UseQueryResult<ProjectDto, unknown>,
];

const usePourPresetGroupsQueries = (params: PourPresetGroupsPageParams): PourPresetGroupsQueries => {
  const projectQuery = useProjectQuery(params.projectId, {
    staleTime: HOUR_IN_MILLISECONDS,
  });

  return [projectQuery];
};

export default usePourPresetGroupsQueries;
